import React, {Fragment} from 'react';

import {Layout} from 'antd';
import '../../../dataPane/dataPane.css';
import '../../work.css';
import ReactEcharts from "echarts-for-react";
import WorkService from "../../WorkService";
const { Content } = Layout;
export default class WorkDataPane extends React.Component {
    constructor(props) {
        super(props);
        this.currentUserInfo = JSON.parse(localStorage.getItem('currentUserAllInfo') || '{}');
        this.urlP = window.location.origin;
        this.state = {
            inspectionItems: [],
            leadsItems: [],
            infoSummaries: [],
            newLeadsSummaries: {},
            todayBoardItems: [],
            sumTodayBoard: 0,
            taskSummaries1: {},
            taskSummaries2: {},
            taskSummaries3: {},
            taskSummaries4: {},
            workStatistics1: {},
            workStatistics2: {},
            workStatistics3: {},
            dataPanel: {}
        }
    }

    componentDidMount() {
        this.getData();
    }
    getData = () => {
        WorkService.boardData({}).then((res) => {
            let todayBoardItems: any = [];
            let sumTodayBoard = 0;
            if (res.todayBoardItems) {
                todayBoardItems = res.todayBoardItems.map((item) => {
                   item.color =  item.type === 'appointed' ? '#3E61F4' :
                       item.type === 'closed' ? '#F8817A' :
                           item.type === 'inspected' ? '#3CF9C9' :
                               item.type === 'repaired' ? '#FFC382' : '';
                   item.value = item.quantity;
                   sumTodayBoard = sumTodayBoard + item.quantity;
                   return item;
                })
            }
            let taskSummaries1,taskSummaries2,taskSummaries3,taskSummaries4;
            if (res.taskSummaries) {
                taskSummaries1 = res.taskSummaries.filter(obj => obj.type === 'newLeads').length > 0 ? res.taskSummaries.filter(obj => obj.type === 'newLeads')[0] : [];
                taskSummaries2 = res.taskSummaries.filter(obj => obj.type === 'confirmVisit').length > 0 ? res.taskSummaries.filter(obj => obj.type === 'confirmVisit')[0] : [];
                taskSummaries3 = res.taskSummaries.filter(obj => obj.type === 'followVisit').length > 0 ? res.taskSummaries.filter(obj => obj.type === 'followVisit')[0] : [];
                taskSummaries4 = res.taskSummaries.filter(obj => obj.type === 'followMaintenance').length > 0 ? res.taskSummaries.filter(obj => obj.type === 'followMaintenance')[0] : [];
            }
            let workStatistics1,workStatistics2;
            if (res.workStatistics) {
                workStatistics1 = res.workStatistics.filter(obj => obj.type === '1').length > 0 ?  res.workStatistics.filter(obj => obj.type === '1')[0] : {};
                workStatistics2 = res.workStatistics.filter(obj => obj.type === '2').length > 0 ?  res.workStatistics.filter(obj => obj.type === '2')[0] : {};
            }
            let workStatistics3: any = {};
            workStatistics3.completedQuantity = (workStatistics1.completedQuantity || 0) + (workStatistics2.completedQuantity || 0);
            workStatistics3.pendingQuantity = (workStatistics1.pendingQuantity || 0) + (workStatistics2.pendingQuantity || 0);
            workStatistics3.closedQuantity = (workStatistics1.closedQuantity || 0) + (workStatistics2.closedQuantity || 0);
            workStatistics3.totalQuantity =  workStatistics3.completedQuantity + workStatistics3.pendingQuantity + workStatistics3.closedQuantity;
            workStatistics3.perNum = Math.ceil((workStatistics3.completedQuantity/workStatistics3.totalQuantity) * 100);
            this.setState({
                dataPanel: res || {},
                inspectionItems: res.inspectionItems || [],
                leadsItems: res.leadsItems || [],
                newLeadsSummaries: res.newLeadsSummaries || {},
                infoSummaries: res.infoSummaries || [],
                todayBoardItems: todayBoardItems,
                sumTodayBoard: sumTodayBoard,
                taskSummaries1: taskSummaries1,
                taskSummaries2: taskSummaries2,
                taskSummaries3: taskSummaries3,
                taskSummaries4: taskSummaries4,
                workStatistics1: workStatistics1,
                workStatistics2: workStatistics2,
                workStatistics3: workStatistics3
            })
        })
    }
    getOption(data: any = []) {
        let names = data.map(item => {
            return item.name;
        });
        let values = data.map(item => {
            return item.quantity;
        })
        let max;
        max = Math.max(...values);
        let interval;
        if (max < 6) {
            interval = 1
        } else {
            interval = Math.floor(max / 6);
        }
        const option = {
            grid: {
                left: '5%',
                right: '5%',
                bottom: '10%',
                top: '20%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: names,
                axisLine: {
                    lineStyle: {
                        color: '#fff',
                        opacity: 0.1
                    }
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: 12
                }
            },
            yAxis: {
                type: 'value',
                max: max,
                interval: interval,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    lineStyle: {
                        color: '#fff',
                        opacity: 0.1
                    }
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: 12
                }
            },
            series: [{
                data: values,
                type: 'bar',
                barWidth: '16%',
                label: {
                    show: true,
                    position: 'top',
                    color: '#fff',
                    fontSize: 14
                },
                itemStyle: {
                    color: function(params) {
                        // 定义每个柱子的颜色
                        const colors = [
                            '#4B79FF',  // 线索
                            '#FFA755',  // 预约到店
                            '#55FFD6'   // 已检测
                        ];
                        return colors[params.dataIndex];
                    },
                    borderRadius: [4, 4, 0, 0]  // 柱状图顶部圆角
                }
            }],
            backgroundColor: 'transparent'  // 深蓝色背景
        };
        return option;
    }
    getOption2(data: any = {}) {
        let max;
        if (data.values) {
            max = Math.max(...data.values);
        }
        let interval;
        if (max < 6) {
            interval = 1
        } else {
            interval = Math.floor(max / 6);
        }
        const option = {
            backgroundColor: 'transparent',
            grid: {
                top: '10%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: true,
                data: data.dates || [],
                axisLine: {
                    lineStyle: {
                        color: '#1e3f8f'
                    }
                },
                axisLabel: {
                    color: '#7d90bc'
                }
            },
            yAxis: {
                type: 'value',
                min: 0,
                max: max,
                interval: interval,
                axisLine: {
                    lineStyle: {
                        color: '#1e3f8f'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: '#1e3f8f',
                        opacity: 0.3
                    }
                },
                axisLabel: {
                    color: '#7d90bc'
                }
            },
            series: [{
                data: data.values || [],
                type: 'line',
                smooth: true,
                symbol: 'circle',
                symbolSize: 8,
                itemStyle: {
                    color: '#4b85ea'
                },
                lineStyle: {
                    color: '#4b85ea',
                    width: 3
                },
                areaStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0,
                            color: 'rgba(75, 133, 234, 0.3)'
                        }, {
                            offset: 1,
                            color: 'rgba(75, 133, 234, 0)'
                        }]
                    }
                }
            }]
        };
        return option;
    }
    getOption3(data: any = []) {
        const option = {
            tooltip: {
                trigger: 'item'
            },
            color: ['#4B79FF', '#41E9C3', '#FFB672'],
            series: [{
                name: '客户分布',
                type: 'pie',
                radius: ['65%', '85%'],
                avoidLabelOverlap: false,
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                },
                data: data
            }]
        };
        return option;
    }
    getOption4(color, data: any = {}, str) {
        const option = {
            series: [
                {
                    type: 'gauge',
                    startAngle: 90,
                    endAngle: -270,
                    radius: '100%',
                    center: ['50%', '50%'],
                    pointer: {
                        show: false
                    },
                    progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 0,
                                colorStops: [{
                                    offset: 0,
                                    color: color
                                }, {
                                    offset: 1,
                                    color: color
                                }]
                            }
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            width: 10,
                            color: [[1, 'rgba(25,25,50,0.3)']]
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    data: [{
                        value: data.completedQuantity/(data.pendingQuantity + data.completedQuantity + data.closedQuantity) * 100 || 0,
                        name: str,
                        title: {
                            offsetCenter: ['0%', '40%']
                        },
                        detail: {
                            offsetCenter: ['0%', '0%']
                        }
                    }],
                    title: {
                        fontSize: 14,
                        color: '#fff'
                    },
                    detail: {
                        width: 80,
                        height: 18,
                        fontSize: 26,
                        color: color,
                        formatter: `${data.completedQuantity || 0}/${(data.pendingQuantity || 0) + (data.completedQuantity || 0) + (data.closedQuantity || 0)}`
                    }
                }
            ],
            backgroundColor: 'transparent'
        };
        return option;
    }
    render() {
        return (
            <>
                <Content className="conContent mainBg" style={{height: 'fit-content',minHeight: '100vh'}}>
                    <div className="dis_center_r" style={{position: 'absolute', left: '30px', top: '44px', zIndex: 1111}}>
                        <div className="divHover" onClick={() => {
                            this.props.history.push('/inspection');
                        }} style={{color: 'aqua'}}>
                            <img className="marginR_10" style={{width: '30px'}} src={require('../../../../assets/newPic/returnMenu.png')}/>退出全屏
                        </div>
                    </div>
                    <div className="firstBox" style={{height: '90px'}}>
                        <div className="titBox" style={{display: 'flex', alignItems: 'center'}}>
                            <div className="dealerNameCls">{this.currentUserInfo.partyName}</div>
                        </div>
                    </div>
                    <div className="dis_center_r">
                        <div style={{flex: 2}} className="marginR_20">
                            <div className="dataCls marginB_20" style={{height: '320px'}}>
                                <div className="titConCls">
                                    <img style={{width: '4px'}} src={require('../../../../assets/work/pic7.png')}/>
                                    <div className="marginL_10 marginR_10">今日待办</div>
                                    <img style={{width: '200px'}} src={require('../../../../assets/work/pic5.png')}/>
                                </div>
                                <section style={{padding: '20px'}}>
                                    <div className="dis_center_r marginB_20">
                                        <div className="conData marginR_30">
                                            <img style={{width: '50px'}} className="marginR_20" src={require('../../../../assets/work/pic1.png')}/>
                                            <div style={{flex: 1}}>
                                                <div className="fonCon1">{this.state.taskSummaries1.pendingQuantity}</div>
                                                <div className="fonCon2">新增线索</div>
                                            </div>
                                        </div>
                                        <div className="conData">
                                            <img style={{width: '50px'}} className="marginR_20" src={require('../../../../assets/work/pic2.png')}/>
                                            <div style={{flex: 1}}>
                                                <div className="fonCon1">{this.state.taskSummaries2.pendingQuantity}</div>
                                                <div className="fonCon2">预约跟踪</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dis_center_r">
                                        <div className="conData marginR_30">
                                            <img style={{width: '50px'}} className="marginR_20" src={require('../../../../assets/work/pic3.png')}/>
                                            <div style={{flex: 1}}>
                                                <div className="fonCon1">{this.state.taskSummaries3.pendingQuantity}</div>
                                                <div className="fonCon2">今日跟进</div>
                                            </div>
                                        </div>
                                        <div className="conData">
                                            <img style={{width: '50px'}} className="marginR_20" src={require('../../../../assets/work/pic4.png')}/>
                                            <div style={{flex: 1}}>
                                                <div className="fonCon1">{this.state.taskSummaries4.pendingQuantity}</div>
                                                <div className="fonCon2">今日回访</div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="dataCls" style={{height: '560px', overflow: 'hidden'}}>
                                <div className="titConCls marginB_10">
                                    <img style={{width: '4px'}} src={require('../../../../assets/work/pic7.png')}/>
                                    <div className="marginL_10 marginR_10">新增线索</div>
                                    <img style={{width: '200px'}} src={require('../../../../assets/work/pic5.png')}/>
                                </div>
                                <ReactEcharts style={{width: '100%', height: '170px'}} option={this.getOption2(this.state.newLeadsSummaries)} />
                                <section className="marginT_20">
                                    <div className="dis_center_r marginB_20" style={{justifyContent: 'left', marginLeft: '20px'}}>
                                        <img style={{width: '4px'}} src={require('../../../../assets/work/pic7.png')}/>
                                        <div className="marginL_10 marginR_10 colTitEr">线索列表</div>
                                        <img style={{width: '150px'}} src={require('../../../../assets/work/pic5.png')}/>
                                    </div>
                                    <section style={{padding: '0 20px'}}>
                                        <div className="dis_center_r insListCls" style={{padding: '0 10px'}}>
                                            <div className="flex_1_left">客资类型</div>
                                            <div className="flex_1_left">联系方式</div>
                                            <div className="flex_1_left">线索日期</div>
                                        </div>
                                        <section style={{overflowY: 'scroll', height: '210px'}}>
                                            {this.state.leadsItems.map((item: any) => {
                                                return (
                                                    <div className="dis_center_r colFFF" style={{lineHeight: '40px', height: '40px', padding: '0 10px', borderBottom: '2px solid rgba(0, 228, 255, 0.4)'}}>
                                                        <div className="flex_1_left">{item.contactType === 'mobile' ? '手机号' :
                                                            item.contactType === 'weixin' ? '微信' : ''}</div>
                                                        <div className="flex_1_left">{item.contactType === 'mobile' ? item.phoneNumber :
                                                            item.contactType === 'weixin' ? item.wechatId : ''}</div>
                                                        <div className="flex_1_left">{item.clueDate}</div>
                                                    </div>
                                                )
                                            })}
                                        </section>
                                    </section>
                                </section>
                            </div>
                        </div>
                        <div style={{flex: 3}} className="marginR_20">
                            <div className="dis_center_r marginB_10" style={{paddingTop: '20px', justifyContent: 'end'}}>
                                <div className="marginR_40 dis_center_r eWH_P" style={{border: '1px solid rgba(255, 255, 255, 0.5)', borderRadius: '50%'}}>
                                    <div className="eCls dis_center_r eWH">
                                        <ReactEcharts style={{width: '100%', height: '100%'}} option={this.getOption3(this.state.todayBoardItems)} />
                                    </div>
                                </div>
                                <div className="dataCls" style={{width: '330px', height: '420px'}}>
                                    <div className="tit3 dis_center_r">
                                        <label>今日成交</label>
                                        <div className="flex_1_right">{this.state.dataPanel.totalAmount}</div>
                                    </div>
                                    <div style={{padding: '20px'}}>
                                        {this.state.todayBoardItems.map((item, index) => {
                                            return (
                                                <div className="dis_center_r tit4">
                                                    <label className="marginR_10"
                                                           style={{display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%', background: item.color}}></label>
                                                    <div className="flex_1_left">{item.name}</div>
                                                    <span>{item.quantity}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="dataCls" style={{height: '450px'}}>
                                <div className="titConCls">
                                    <img style={{width: '4px'}} src={require('../../../../assets/work/pic7.png')}/>
                                    <div className="marginL_10 marginR_10">信息汇总</div>
                                    <img style={{width: '200px'}} src={require('../../../../assets/work/pic5.png')}/>
                                </div>
                                <ReactEcharts style={{width: '100%', height: '340px'}} option={this.getOption(this.state.infoSummaries)} />
                            </div>
                        </div>
                        <div style={{flex: 2}}>
                            <div className="dataCls marginB_20" style={{height: '430px'}}>
                                <div className="titConCls">
                                    <img style={{width: '4px'}} src={require('../../../../assets/work/pic7.png')}/>
                                    <div className="marginL_10 marginR_10">工单</div>
                                    <img style={{width: '200px'}} src={require('../../../../assets/work/pic5.png')}/>
                                </div>
                                <div className="marginB_20" style={{padding: '20px 30px'}}>
                                    <div className="dis_center_r tit5">
                                        <label>工单统计</label>
                                        <div className="flex_1_right">{this.state.workStatistics3.completedQuantity}/{this.state.workStatistics3.totalQuantity}</div>
                                    </div>
                                    <div className="workLieBox">
                                        <div className="progress-bar">
                                            <div className="progress-fill" style={{width: this.state.workStatistics3.perNum + '%'}}>
                                                <div className="workWord">{this.state.workStatistics3.perNum}%</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="dis_center_r">
                                    <div className="dis_center_r marginR_40" style={{width: '180px', height: '180px', position: 'relative'}}>
                                        <div className="ePieCls dis_center_r"></div>
                                        <div style={{width: '175px', height: '175px', position: 'absolute', border: '1px solid rgba(255, 255, 255, 0.5)', borderRadius: '50%',left: '5px', top: '5px'}}></div>
                                        <ReactEcharts style={{width: '180px', height: '180px', position: 'absolute', left: 0, top: 0}} option={this.getOption4('#88C8FF', this.state.workStatistics1, '线索')} />
                                    </div>
                                    <div className="dis_center_r" style={{width: '180px', height: '180px', position: 'relative'}}>
                                        <div className="ePieCls dis_center_r"></div>
                                        <div style={{width: '175px', height: '175px', position: 'absolute', border: '1px solid rgba(255, 255, 255, 0.5)', borderRadius: '50%',left: '5px', top: '5px'}}></div>
                                        <ReactEcharts style={{width: '180px', height: '180px', position: 'absolute', left: 0, top: 0}} option={this.getOption4('#FFC382', this.state.workStatistics2, '跟进')} />
                                    </div>

                                </div>
                            </div>
                            <div className="dataCls" style={{height: '450px', overflow: 'hidden'}}>
                                <div className="titConCls">
                                    <img style={{width: '4px'}} src={require('../../../../assets/work/pic7.png')}/>
                                    <div className="marginL_10 marginR_10">检测列表</div>
                                    <img style={{width: '200px'}} src={require('../../../../assets/work/pic5.png')}/>
                                </div>
                                <div style={{padding: '10px 20px'}}>
                                    <div className="dis_center_r insListCls" style={{padding: '0 10px'}}>
                                        <div className="flex_1_left">客户</div>
                                        <div className="flex_1_left">车牌</div>
                                        <div className="flex_1_left">客源</div>
                                        <div className="flex_1_left">结论</div>
                                    </div>
                                    <section style={{overflowY: 'scroll', height: '380px'}}>
                                        {this.state.inspectionItems.map((item: any) => {
                                            return (
                                                <div className="dis_center_r colFFF" style={{lineHeight: '40px', height: '40px', padding: '0 10px', borderBottom: '2px solid rgba(0, 228, 255, 0.4)'}}>
                                                    <div className="flex_1_left">{item.carOwnerName}</div>
                                                    <div className="flex_1_left">{item.carNumber}</div>
                                                    <div className="flex_1_left">{item.customerSource}</div>
                                                    <div className="flex_1_left">{item.inspectionResult ? item.inspectionResult : '----'}</div>
                                                </div>
                                            )
                                        })}
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </Content>
            </>
        )
    }
}
